'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _buttons = require('@sitebase/ui-kit/es/buttons');

var _components = require('../../components');

var _constants = require('../../constants');

var _common = require('../../utils/common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * AmountButtons component.
 * @returns {ReactElement} React element
 */
var AmountButtonsComponent = function (_React$Component) {
  (0, _inherits3.default)(AmountButtonsComponent, _React$Component);

  /**
   * Component constructor.
   *
   * @param {object} props element props
   * @public
   */
  function AmountButtonsComponent(props) {
    (0, _classCallCheck3.default)(this, AmountButtonsComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AmountButtonsComponent.__proto__ || (0, _getPrototypeOf2.default)(AmountButtonsComponent)).call(this, props));

    _this.updateAmount = _this.updateAmount.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(AmountButtonsComponent, [{
    key: 'updateAmount',


    /**
     * When a button is pressed this function make sure to dispatch
     * an action to update the amount value with the proper amount
     *
     * @param {string} amount The amount to add
     * @returns {void}
     */
    value: function updateAmount(amount) {
      var _this2 = this;

      return function (event) {
        var _props = _this2.props,
            change = _props.change,
            currentAmountValue = _props.currentAmountValue;


        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        setTimeout(function () {
          change(_constants.QD_RF_FORM_NAME, _constants.QD_RF_FIELD_AMOUNT, (0, _common.sumValues)(currentAmountValue || 0, amount));
        });
      };
    }

    /**
     * Render method for the component
     * @returns {Element<*>} the react element
     */

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      //make sure that at most only 5 buttons are used
      var amountValues = (this.props.amountValues || []).slice(0, 5);
      var currencyCode = this.props.currencyCode;


      return _react2.default.createElement(
        _buttons.ButtonGroup,
        { className: 'qd-amount-buttons', columns: 3, outfit: 'blue-30 normal' },
        amountValues.map(function (amountValue, index) {
          return _react2.default.createElement(_components.AmountButton, {
            amountValue: amountValue,
            currencyCode: currencyCode,
            key: index,
            onClick: _this3.updateAmount(amountValue),
            tabIndex: _this3.props.formElementIndex
          });
        })
      );
    }
  }]);
  return AmountButtonsComponent;
}(_react2.default.Component);

exports.default = AmountButtonsComponent;